import { styled, css, Alert, AlertProps } from '@mui/material'
import { AlertStylesProps } from './Alert.types'
import Heading from '../Heading'
import Text from '../Text'
import Button from '../Button'
import IconButton from '../IconButton'

export const AlertWrapper = styled(Alert, {
  shouldForwardProp: (prop) => !['show'].includes(String(prop))
})<AlertStylesProps & AlertProps>(
  ({
    theme,
    severity = 'success',
    color = severity,
    size = 'medium',
    align = 'left',
    variant = 'outlined'
  }) => css`
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 14px;
    padding: 12px 16px;
    min-height: 48px;
    min-width: 300px;
    max-width: 520px;
    border-radius: 8px;
    text-align: ${align};

    .MuiAlert-icon,
    .MuiAlert-message,
    .MuiAlert-action {
      padding: 0;
      margin: 0;
    }

    .MuiAlert-message {
      flex: 1;
    }

    .MuiAlert-icon {
      font-size: 1.6em;
      margin: 0 0 2px;
    }

    ${variant === 'outlined' &&
    css`
      background-color: ${theme.palette[color].light};
      border-color: ${theme.palette[color].main};
      color: ${theme.palette[color].dark};
      .MuiAlert-icon {
        color: ${theme.palette[color].main};
      }
    `}

    ${variant === 'standard' &&
    css`
      background-color: ${theme.palette.grey[900]};
      color: ${theme.palette.common.white};
      .MuiAlert-icon {
        color: ${theme.palette[color].light};
      }
    `}

    ${size === 'medium' &&
    css`
      min-height: 40px;
      font-size: 12px;
      padding: 8px 12px;
      gap: 10px;
    `}

    ${size === 'small' &&
    css`
      min-height: 32px;
      font-size: 12px;
      padding: 6px 8px;
      gap: 8px;
    `}

    ${size === 'xsmall' &&
    css`
      min-height: 24px;
      font-size: 11px;
      padding: 4px 8px;
      gap: 8px;
    `}
  `
)

export const AlertTitle = styled(Heading)(
  () => css`
    color: inherit;
    font-size: 1.2em;
    text-align: inherit;
  `
)

export const AlertMessage = styled(Text)(
  () => css`
    color: inherit;
    font-size: 1em;
    text-align: inherit;
  `
)

export const AlertButton = styled(Button)(() => css``)
AlertButton.defaultProps = {
  variant: 'text',
  size: 'small',
  label: 'Close'
}

export const AlertIconButton = styled(IconButton)(() => css``)
AlertIconButton.defaultProps = {
  size: 'small',
  icon: 'MdClose'
}
